import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderRightComponent } from "./med-icon-border-right.component";

@NgModule({
  declarations: [
    MedIconBorderRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderRightComponent,
  ],
})
export class MedIconBorderRightModule { }
